import React from 'react'

const WeekStatsHeader = () => {
  return (
    <div className='text-caption-xl flex flex-col gap-1.5 items-start text-secondary-400'>
        <span>Tymbeři</span>
        <span>Hodiny</span>
    </div>
  )
}

export default WeekStatsHeader
